export interface Category {
  id: string;
  name: string;
  url: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageSeq: 'cat-shoes-2026',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageSeq: 'cat-hoodies-2026',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageSeq: 'cat-tshirts-2026',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageSeq: 'cat-jackets-2026',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageSeq: 'cat-pants-2026',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageSeq: 'cat-headwear-2026',
  },
  {
    id: 'sets',
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageSeq: 'cat-sets-2026',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageSeq: 'cat-underwear-2026',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageSeq: 'cat-jersey-2026',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageSeq: 'cat-accessories-2026',
  },
  {
    id: 'bags',
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageSeq: 'cat-bags-2026',
  },
  {
    id: 'belts',
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageSeq: 'cat-belts-2026',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageSeq: 'cat-perfumes-2026',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageSeq: 'cat-other-2026',
  },
];